import { loader } from 'graphql.macro'

export default async function destroyTicket ({ dataLoaders, variables }) {
  const schema = loader('./destroyTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id
    }
  })
  return response.destroyTicket
}
